import { render, staticRenderFns } from "./Subgroups.vue?vue&type=template&id=4bdfe944&scoped=true"
import script from "./Subgroups.vue?vue&type=script&lang=js"
export * from "./Subgroups.vue?vue&type=script&lang=js"
import style0 from "./Subgroups.vue?vue&type=style&index=0&id=4bdfe944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdfe944",
  null
  
)

export default component.exports